import React, { useState, useEffect } from "react";
import Navigation from "./Navigation";
import audiophile from "./images/client-audiophile.svg";
import databiz from "./images/client-databiz.svg";
import maker from "./images/client-maker.svg";
import meet from "./images/client-meet.svg";
import logo from "./images/logo.svg";
import SideBar from "./SideBar";

function App() {
  const [subFeatures, setSubFeatures] = useState(false);
  const [subCompanyList, setSubCompanyList] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(true);

  const handleClick = (e) => {
    const value = e.currentTarget.value;
    if (value === "features") {
      setSubFeatures(!subFeatures);
      setSubCompanyList(false);
    } else if (value === "company") {
      setSubCompanyList(!subCompanyList);
      setSubFeatures(false);
    } else if (value === "openMenu") {
      setIsMenuOpen(!isMenuOpen);
    } else if (value === "closeMenu") {
      setIsMenuOpen(!isMenuOpen);
    } else {
      setSubCompanyList(false);
      setSubFeatures(false);
    }
  };
  return (
    <main className="main">
      <nav className="navigation">
        <div className="logo">
          <img src={logo} alt="snap-logo" />
        </div>
        <Navigation
          subCompanyList={subCompanyList}
          subFeatures={subFeatures}
          handleClick={handleClick}
        />
        <SideBar
          subCompanyList={subCompanyList}
          subFeatures={subFeatures}
          handleClick={handleClick}
          isMenuOpen={isMenuOpen}
        />
      </nav>
      <section className="container">
        <div className="heading">
          <h1>
            <span>Make</span> remote work
          </h1>
          <p className="para">
            get your team in sync, no matter your location. streamline process.
            create team rituals, and watch productivity soar.
          </p>
          <button className="learnMoreBtn">learn more</button>
        </div>

        <div className="partner-container">
          <img src={databiz} alt="audiophile" />
          <img src={audiophile} alt="audiophile" />
          <img src={meet} alt="meet" />
          <img src={maker} alt="maker" />
        </div>
        <div className="wallpaper">
          <img id="backgroundImg" src="" alt="wallpaper" />
        </div>
      </section>
    </main>
  );
}
export default App;
